module.exports = __webpack_public_path__ + "static/media/img_index_info.45872987.png";